import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import Spinner from '../Common/Spinner';
import Alert from '../Common/Alert';
import './TestData.css';

const formatDate = (value) => {
  if (!value) return '—';
  const d = new Date(value);
  return isNaN(d.getTime()) ? value : d.toLocaleString();
};

const TestData = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await api.get('/test/data');
      setData(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      const errorMessage =
        err.response?.data?.message ||
        err.response?.data?.error ||
        err.message ||
        'Failed to load test data';
      setError(errorMessage);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Spinner />;

  return (
    <div className="test-data-page">
      <div className="page-header">
        <h1 className="page-title">Test Data</h1>
        <button type="button" className="btn-refresh" onClick={fetchData}>
          Refresh
        </button>
      </div>

      {error && <Alert type="error" message={error} />}

      <div className="card test-data-card">
        <p className="test-data-description">
          Data from <code>TestTable</code> (GET api/test/data). {data.length} row(s).
        </p>
        <div className="table-wrapper">
          <table className="test-data-table">
            <thead>
              <tr>
                <th>Id</th>
                <th>Name</th>
                <th>Code</th>
                <th>Category</th>
                <th>Status</th>
                <th>Quantity</th>
                <th>Amount</th>
                <th>Score</th>
                <th>Active</th>
                <th>Priority</th>
                <th>Created On</th>
                <th>Reference No</th>
              </tr>
            </thead>
            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan={12} className="empty-cell">
                    No records. Add rows to TestTable in the database to see them here.
                  </td>
                </tr>
              ) : (
                data.map((row) => (
                  <tr key={row.id}>
                    <td>{row.id}</td>
                    <td title={row.description || ''}>{row.name ?? '—'}</td>
                    <td>{row.code ?? '—'}</td>
                    <td>{row.category ?? '—'}</td>
                    <td>{row.status ?? '—'}</td>
                    <td className="num">{row.quantity ?? '—'}</td>
                    <td className="num">{row.amount != null ? Number(row.amount).toFixed(2) : '—'}</td>
                    <td className="num">{row.score != null ? Number(row.score).toFixed(2) : '—'}</td>
                    <td>{row.isActive ? 'Yes' : 'No'}</td>
                    <td className="num">{row.priority ?? '—'}</td>
                    <td>{formatDate(row.createdOn)}</td>
                    <td>{row.referenceNo ?? '—'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TestData;
